export const CONTRACT_ADDRESS   = "0xcdD5f72Ad08e4c834a4FE0aA6a466bd9CaBEA222";
export const AI_SIGNER_ADDRESS  = "0x2032Fa3f981eCc614f459e43d1D7CE17A604A9C4";
export const PLATFORM_FEE_PCT   = 3;
export const OG_TO_USD_RATE     = 0.83;

export const ZERO_G_CHAIN = {
  chainId: "0x40DA",
  chainName: "0G-Galileo-Testnet",
  nativeCurrency: { name: "0G", symbol: "0G", decimals: 18 },
  rpcUrls: ["https://evmrpc-testnet.0g.ai"],
  blockExplorerUrls: ["https://chainscan-newton.0g.ai"],
};

export const CATEGORIES = ["All","Music","Tech","Art","Gaming","Comedy","Wellness","Sports"];

export const LOCATIONS = [
  { city:"Los Angeles",   state:"CA", flag:"🌆" },
  { city:"New York",      state:"NY", flag:"🗽" },
  { city:"San Francisco", state:"CA", flag:"🌉" },
  { city:"Miami",         state:"FL", flag:"🏖️" },
  { city:"Austin",        state:"TX", flag:"🌇" },
];

// JS design tokens — used in inline styles
export const V = {
  text:"#111827", text2:"#374151", muted:"#6B7280", mutedL:"#9CA3AF",
  border:"#E5E7EB", borderS:"#F3F4F6",
  surface:"#F7F7FB", surface2:"#F0EFF8",
  brand:"#6D28D9", brandL:"#7C3AED",
  b50:"#F5F3FF", b100:"#EDE9FE",
};